"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 1.4,
  d: "M3.7 14V6A2.3 2.3 0 0 1 6 3.7h8c1.271 0 2.3 1.028 2.3 2.298v8.005A2.297 2.297 0 0 1 14 16.3H6A2.3 2.3 0 0 1 3.7 14Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--background-color, var(--smar--com--color--neutral--200,#a8acbd))",
  d: "M12.467 4.4H7.55v7.616a.5.5 0 0 0 .827.378l1.316-1.14a.5.5 0 0 1 .657.001l1.288 1.129a.5.5 0 0 0 .83-.376z"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=CollectionSingleFillIcon20.js.map